import React from 'react';
import PropTypes from 'prop-types';
import { ButtonUnstyled } from '@mui/base';

import { StandardButtonStyle, StaticStandardButtonStyle, StandardErrorButtonStyle } from './styles';

const StandardButton = ({
  children,
  onClick,
  height,
  width,
  fontSize,
  type,
  disabled,
  isStatic,
  style,
  href,
  target,
  variant,
  ...props
}) => {
  const currentOnClick = (event) => {
    if (href) window.open(href, target || '_blank', 'noopener,noreferrer');
    onClick(event);
  };

  const componentVersion = () => {
    if (isStatic) return StaticStandardButtonStyle;
    if (variant === 'error') return StandardErrorButtonStyle;
    return StandardButtonStyle;
  };

  return (
    <ButtonUnstyled
      style={{ ...style, height, width, fontSize, lineHeight: '100%' }}
      type={type}
      disabled={disabled}
      component={componentVersion()}
      onClick={currentOnClick}
      {...props}
    >
      {children}
    </ButtonUnstyled>
  );
};

StandardButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  onClick: PropTypes.func,
  height: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  width: PropTypes.string,
  fontSize: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  isStatic: PropTypes.bool,
  style: PropTypes.shape(),
  variant: PropTypes.string,
};

StandardButton.defaultProps = {
  width: '86px',
  height: '34px',
  fontSize: '14px',
  href: '',
  target: '',
  type: '',
  disabled: false,
  isStatic: false,
  style: {},
  variant: 'normal',
  onClick: () => {},
};

export default StandardButton;
